<template>
<CCard>
  <CCardBody>
<div>
    <FixedPlugin></FixedPlugin>
</div>
</CCardBody>
</CCard>
</template>

<script>
import { APIService } from "../../../apiservice.js";
import CTableWrapper from "../../tables/Table";
import Locationmap from "@/components";
import Dropdown from "vue-simple-search-dropdown";
import { Vselect } from "@/components";
import Swal from "sweetalert2";
import FixedPlugin from "./animalFixedPlugin.vue";
export default {
  components: { CTableWrapper, Locationmap, Vselect,FixedPlugin },

  data() {
    return {
      
    };
  },
  methods: {
  }
};
</script>
